import axios from 'axios'
import { getAdminToken, clearAuthSession, ensureAuthSessionValid } from '../utils/auth'

/**
 * 与 Vue.prototype.$api 同一实例：保证 .env 里 VUE_APP_API_BASE 对所有接口生效。
 * 路径不要带 /api 前缀（baseURL 已含 /api）。
 */
const apiBaseRaw =
  (typeof process !== 'undefined' &&
    process.env &&
    process.env.VUE_APP_API_BASE &&
    String(process.env.VUE_APP_API_BASE).trim()) ||
  `${typeof window !== 'undefined' ? window.location.origin : ''}/api`
export const apiBase = String(apiBaseRaw).replace(/\/$/, '')

const api = axios.create({
  baseURL: apiBase,
  timeout: 15000
})

api.interceptors.request.use(
  (config) => {
    const url = String(config.url || '')
    if (!url.includes('admin/login') && !url.includes('admin/ping')) {
      const state = ensureAuthSessionValid({ touch: true })
      if (!state.valid) {
        if (
          typeof window !== 'undefined' &&
          !String(window.location.hash || '').includes('login')
        ) {
          window.location.hash = '#/login'
        }
        const err = new Error('auth session expired')
        err._authSessionExpired = true
        return Promise.reject(err)
      }
      const t = getAdminToken()
      if (t) {
        config.headers = config.headers || {}
        config.headers.Authorization = `Bearer ${t}`
      }
    }
    return config
  },
  (error) => Promise.reject(error)
)

api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response && error.response.data != null) {
      error.apiBody = error.response.data
    }
    if (error.response == null && error.request) {
      error._networkHint =
        '无法连接接口：请确认后端已启动，且 Nginx/网关已将 /api 转发到 Node，或在 .env 中配置 VUE_APP_API_BASE'
    } else if (error.response && error.response.status === 401) {
      const url = String((error.config && error.config.url) || '')
      if (!url.includes('admin/login')) {
        clearAuthSession()
        if (
          typeof window !== 'undefined' &&
          !String(window.location.hash || '').includes('login')
        ) {
          window.location.hash = '#/login'
        }
      }
    }
    return Promise.reject(error)
  }
)

export default api
